module.exports = __webpack_public_path__ + "img/functional2-img1.803eed79.png";